'use strict';

import InfoPopup from "../shared/InfoPopup"
class BlockDistribution {

	constructor($target) {

		//Private properties
		$target;

		let name = "HELLO";
        let infoPopup

        function init(){
            initModal();
        }

        init();

        function initModal(){
            if($(".modal").length > 0){

                infoPopup = new InfoPopup($(".modal"))

                $('.popup-link').on('click', function (event) {

                    console.log("CLICKED!")

                    event.preventDefault();
            
                    let dataID = $(this).data('target');
            
                    infoPopup.showModal(0);
                    
                });
                
            }

        }
        

		return {

			//Public properties
			name:name,

			publicBlockExample:function(string){

				// $target.append("HELLO!"+string);
				console.log(name)
				console.log(string)
				console.log($target)

			}

		}

	}

}

export default BlockDistribution;